import { render } from "./CardSpecOpus.vue?vue&type=template&id=5fe9cb12"
import script from "./CardSpecOpus.vue?vue&type=script&lang=js"
export * from "./CardSpecOpus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/CardSpecOpus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fe9cb12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fe9cb12', __exports__)) {
    api.reload('5fe9cb12', __exports__)
  }
  
  module.hot.accept("./CardSpecOpus.vue?vue&type=template&id=5fe9cb12", () => {
    api.rerender('5fe9cb12', render)
  })

}


export default __exports__